export const ALL_FILTER = "All";

export function isAggregateFilterValue(value: string | null | undefined) {
  return value == null || value === ALL_FILTER;
}

export function matchesFallbackDimensionSelection(
  selectedValue: string,
  rowValue: string | null | undefined,
  hasConcreteDimension: boolean
) {
  if (selectedValue !== ALL_FILTER) {
    return rowValue === selectedValue;
  }

  if (!hasConcreteDimension) {
    return true;
  }

  return !isAggregateFilterValue(rowValue);
}
